<template>
  <div class="w-full height-100">
    <el-dialog title="" :visible.sync="isShowUser" :direction="direction">
      <template slot="title"
        ><h3 class="fsize16 Add Products text-white">User Details</h3></template
      >
      <!-- <div>
        <div>
          <div>
            <p class="fsize14 font-semibold text-4f4f4f mb-0">
              Order Return Status
            </p>
            <el-select
              v-model="orderReturnStatus"
              placeholder="Select..."
              class="w-full mt-1"
            >
              <el-option
                v-for="status in orderReturnStatusOption"
                :key="status"
                :label="status"
                :value="status"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex justify-center mt-8">
          <vs-button
            class="bg-primary text-white font-semibold py-3 fsize14 px-12 sm-fsize14"
          >
            Submit
          </vs-button>
        </div>
      </div> -->
      <el-table
        :data="userData"
        border
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-colorpd"
      >
        <el-table-column prop="name" label="Name" min-width="100px">
          <!-- <template v-slot="{ row }">
            <p class="fsize12">
              {{row.}}
            </p>
          </template> -->
        </el-table-column>
        <el-table-column prop="email" label="Email" min-width="100px">
        </el-table-column>
        <el-table-column prop="mobile" label="Mobile" min-width="100px">
        </el-table-column>
        <el-table-column prop="address" label="Address" min-width="100px">
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="" :visible.sync="isShowProduct" :direction="direction">
      <template slot="title"
        ><h3 class="fsize18 Add mb-0 Products text-white">Product</h3></template
      >
      <div>
        <ProductTable :selectedOrderReturn="selectedOrderReturn" />
      </div>
    </el-dialog>

    <el-dialog title="" :visible.sync="isShowImage" :direction="direction">
      <template slot="title"
        ><h3 class="fsize18 Add mb-0 Products text-white">Images</h3></template
      >
      <div
        v-if="
          selectedOrderReturn.images && selectedOrderReturn.images.length > 0
        "
      >
        <div class="grid grid-cols-4 gap-6">
          <div
            v-for="(imageUrl, index) in selectedOrderReturn.images"
            :key="`${imageUrl} + ${index}`"
          >
            <div class="elshadow rounded-4px" v-if="imageUrl !== ''">
              <img :src="getImage(imageUrl)" alt="image" class="w-full" />
              <p class="text-center p-2 mb-0">Image {{ index + 1 }}</p>
            </div>
            <div v-else>No Images</div>
          </div>
        </div>
      </div>
      <div v-else class="text-center">No Images</div>
    </el-dialog>

    <el-dialog title="" :visible.sync="isShowVideo" :direction="direction">
      <template slot="title"
        ><h3 class="fsize18 Add mb-0 Products text-white">Video</h3></template
      >
      <div v-if="selectedOrderReturn.video" class="text-center">
        <!-- <soruce src="wdwdwd.mp4" type="video/mp4" /> -->
        <!-- {{ selectedOrderReturn.video }} -->
        <video
          :src="getImage(selectedOrderReturn.video)"
          width="90%"
          height="400px"
          controls
        >
          <!-- <soruce :src="selectedOrderReturn.video" type="video/mp4" /> -->
          Your browser does not support the video tag.
        </video>
      </div>
      <div v-else class="text-center">No Video</div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Order Returns
          </h2>
        </div>
      </div>
    </div>

    <div class="fixed-top bg-white p-6">
      <el-input v-model="search" placeholder="Search here..." />

      <div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-colorpd"
        >
          <el-table-column prop="returnId" label="Return ID" min-width="100px">
          </el-table-column>

          <el-table-column prop="createdAt" label="Date" min-width="100px">
            <template v-slot="{ row }">
              {{ new Date(row.createdAt).toLocaleDateString("en-IN") }}
            </template>
          </el-table-column>

          <el-table-column prop="product" label="Product" min-width="160px">
            <template v-slot="{ row }">
              <p class="fsize12 cursor-pointer" @click="handleViewProduct(row)">
                View Product
              </p>
            </template>
          </el-table-column>

          <el-table-column prop="returnReason" label="Reason" min-width="160px">
            <template v-slot="{ row }">
              <p class="fsize12">{{ row.returnReason }}</p>
              <p class="fsize12" v-if="row.comment">
                Comment: {{ row.comment }}
              </p>
            </template>
          </el-table-column>

          <el-table-column label="Images" min-width="160px">
            <template v-slot="{ row }">
              <p @click="handleViewImage(row)" class="fsize12 cursor-pointer">
                View Images
              </p>
            </template>
          </el-table-column>

          <el-table-column prop="viewVideo" label="Video" min-width="140px">
            <template v-slot="{ row }">
              <p @click="handleViewVideo(row)" class="fsize12 cursor-pointer">
                View Video
              </p>
            </template>
          </el-table-column>

          <el-table-column label="Return Status" min-width="160px">
            <template v-slot="{ row }">
              <div
                v-if="row.returnStatus === 'Pending'"
                class="flex gap-2 items-center"
              >
                <p
                  class="bg-fas w-12 h-12 rounded-full cursor-pointer flex items-center justify-center"
                >
                  <feather-icon
                    svgClasses="w-4 h-4"
                    icon="CheckIcon"
                    @click="handleOrderReturnStatus(row, 'Return Initiated')"
                  />
                </p>
                <p
                  class="bg-fas w-12 h-12 rounded-full flex cursor-pointer items-center justify-center"
                >
                  <feather-icon
                    svgClasses="w-4 h-4"
                    icon="XIcon"
                    @click="handleOrderReturnStatus(row, 'Rejected')"
                  />
                </p>
              </div>
              <div v-else-if="row.returnStatus === 'Rejected'">
                <el-tag type="danger"> Rejected </el-tag>
              </div>
              <div v-else>
                <OrderReturnStatus
                  :itemData="row"
                  @getOrderReturn="getOrderReturn"
                />
              </div>
              <!-- {{ row.orderStatus }} -->
            </template>
          </el-table-column>

          <el-table-column prop="action" label="User Details" min-width="80px">
            <template v-slot="{ row }">
              <!-- <feather-icon
                @click="isShowEdit = true"
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
              /> -->
              <p @click="handleViewUser(row)" class="fsize12 cursor-pointer">
                View User
              </p>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full flex justify-end mt-6" v-if="totalRows > 0">
          <el-pagination
            background
            layout="prev,pager,next"
            :total="totalRows"
            :page-size="perPage"
            @current-change="setPage"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
import { mapState } from "vuex";
import OrderReturnStatus from "./OrderReturnStatus.vue";
import ProductTable from "./ProductTable";
export default {
  data() {
    return {
      direction: "rtl",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      selectedOrderReturn: {},
      search: "",
      isShowProduct: false,
      isShowImage: false,
      isShowVideo: false,
      isShowUser: false,
      orderReturnStatus: "",
      orderReturnStatusOption: [
        "Return Initiated",
        "Pickup",
        "Item Received",
        "Refund Initiated",
        "Refund Credited",
      ],
      tableData: [
        // {
        //   returnID: "AF220",
        //   reason: "test",
        // },
        // {
        //   returnID: "AF220",
        //   reason: "test",
        // },
        // {
        //   returnID: "AF220",
        //   reason: "test",
        // },
        // {
        //   returnID: "AF220",
        //   reason: "test",
        // },
        // {
        //   returnID: "AF220",
        //   reason: "test",
        // },
      ],
      userData: [],
    };
  },
  components: {
    ProductTable,
    OrderReturnStatus,
  },
  methods: {
    getImage(img) {
      // console.log(`${this.$imageURL}/${img}`);
      return `${this.$imageURL}/${img}`;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },

    handleClose() {},
    handleViewProduct(row) {
      this.isShowProduct = true;
      this.selectedOrderReturn = row;
    },
    handleViewImage(row) {
      this.isShowImage = true;
      this.selectedOrderReturn = row;
    },
    handleViewVideo(row) {
      this.isShowVideo = true;
      this.selectedOrderReturn = row;
    },
    handleViewUser(row) {
      this.selectedOrderReturn = row;
      let user = this.selectedOrderReturn.userData;
      let data = {
        name: user.firstName + " " + user.lastName,
        email: user.email,
        mobile: user.mobile,
        address: user.addressId
          ? user.addressId.address1 + " " + user.addressId.address2
          : "",
      };
      this.userData = [];
      this.userData[0] = data;
      this.isShowUser = true;
    },
    async handleOrderReturnStatus(itemData, status = "") {
      // const result = await this.confirmAlert();
      // if (result.isConfirmed) {
      const payload = {
        orderReturnId: itemData._id,
        returnStatus: status,
        adminId: this.login._id,
        isAdmin: true,
      };
      // if (msg) Object.assign(payload, { cancelledReason: msg });
      // console.log(payload);
      // return console.log(this.orderStatus);
      try {
        let data = await this.$store.dispatch(
          "EcomOrderReturn/updateOrderReturn",
          payload
        );
        if (data.code === 200) {
          this.getOrderReturn();
          // this.currentStatus = this.orderStatus;
          // this.ruleForm.cancelMsg = "";
          return this.$notify({
            message: `Status: ${status}`,
            position: "bottom-right",
          });
        }
        // this.orderStatus = this.currentStatus;
      } catch (e) {
        // this.ruleForm.cancelMsg = "";
        // this.orderStatus = this.currentStatus;
        return this.$notify.error({
          message: "Failed to update Order Return Status",
          position: "bottom-right",
        });
      }
      // } else this.orderStatus = this.currentStatus = "Dispatch";
    },
    async getOrderReturn() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };
      let loader;

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const getOrderReturn = await this.$store.dispatch(
          "EcomOrderReturn/getOrderReturn",
          payload
        );
        // console.log(getCoupon);
        loader.close();
        if (getOrderReturn.code === 200) {
          this.totalRows = this.orderReturnDetails.totalCount;
          this.tableData = this.orderReturnDetails.result;
        }
      } catch (error) {
        loader.close();
      }

      // console.log(this.orderDetails);
    },
    setPage(page) {
      this.currentPage = page;
    },
  },
  watch: {
    async currentPage() {
      await this.getOrderReturn();
    },
    search: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getOrderReturn();
      }, 500),
    },
  },
  computed: {
    ...mapState("user", ["users"]),
    ...mapState("admin", ["login"]),
    // ...mapState("EcomProduct", ["productDetails"]),
    ...mapState("EcomOrderReturn", ["orderReturnDetails"]),
  },
  mounted() {
    this.getOrderReturn();
  },
};
</script>
